import { DISPLAY_STAGE_LABEL, FAIXA_LABEL, STATUS_LABEL, type CommercialStatusKey, type DisplayStageKey, type Faixa } from '@sc/shared/domain';

const STAGE_TONE: Record<DisplayStageKey, string> = {
  iniciou: 'tone-gray',
  respondendo: 'tone-gray',
  fora_do_perfil: 'tone-dark',
  qualificado: 'tone-blue',
  enviado_whatsapp: 'tone-yellow',
  em_atendimento: 'tone-teal',
  convertido: 'tone-green',
  nao_fechou: 'tone-dark',
  abandonou: 'tone-red',
};

const STATUS_TONE: Record<CommercialStatusKey, string> = {
  novo: 'tone-blue',
  em_contato: 'tone-teal',
  visita_agendada: 'tone-teal',
  proposta_enviada: 'tone-yellow',
  fechado: 'tone-green',
  nao_fechou: 'tone-dark',
};

export function StageBadge({ stage }: { stage: DisplayStageKey }) {
  return (
    <span className={`badge ${STAGE_TONE[stage]}`}>
      <i aria-hidden="true" />
      {DISPLAY_STAGE_LABEL[stage]}
    </span>
  );
}

export function StatusBadge({ status }: { status: CommercialStatusKey | null }) {
  if (!status) return <span className="muted">—</span>;
  return (
    <span className={`badge ${STATUS_TONE[status]}`}>
      <i aria-hidden="true" />
      {STATUS_LABEL[status]}
    </span>
  );
}

const TIER_TONE: Record<Faixa, string> = { quente: 'tone-red', morno: 'tone-yellow', frio: 'tone-gray' };

/** Faixa da pontuação. Sênior e manutenção aparecem no lugar quando se aplicam. */
export function TierBadge({ tier, score, senior, manutencao }: { tier: Faixa | null; score?: number | null; senior?: boolean; manutencao?: boolean }) {
  if (manutencao) return <span className="badge tone-blue"><i aria-hidden="true" />Manutenção</span>;
  if (!tier) return <span className="muted">—</span>;
  return (
    <span className="tier">
      <span className={`badge ${TIER_TONE[tier]}`}>
        <i aria-hidden="true" />
        {FAIXA_LABEL[tier]}
        {score != null && <span className="mono"> {score}</span>}
      </span>
      {senior && <span className="badge tone-dark" title="Conta alta, indústria ou rural">Sênior</span>}
    </span>
  );
}

export function ExampleBadge({ children = 'Dados de exemplo' }: { children?: string }) {
  return <span className="example-badge">{children}</span>;
}
